var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-component'),_c('orders'),_c('buyers'),_c('messages'),_c('cupons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }